import { Component, OnInit } from '@angular/core';
import { PopupService } from './services/popup.service';

@Component({
  selector: 'app-popup',
  template: `
    <div class="modal fade show" style="display: block;" *ngIf="show">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body text-center">
            <i [class]="getIcon()" style="font-size: 48px;"></i>
            <h4 class="mt-3">{{ data?.message }}</h4>
            <button class="btn btn-primary mt-3" (click)="close()">OK</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show" *ngIf="show"></div>
  `,
  styles: [`
    .text-success { color: #28a745 !important; }
    .text-danger { color: #dc3545 !important; }
  `]
})
export class PopupComponent implements OnInit {
  show = false;
  data: any = null;

  constructor(private popupService: PopupService) {}

  ngOnInit() {
    this.popupService.show$.subscribe(show => this.show = show);
    this.popupService.data$.subscribe(data => this.data = data);
  }

  getIcon() {
    return this.data?.type === 'success' ? 'fas fa-check-circle text-success' : 'fas fa-times-circle text-danger';
  }

  close() {
    this.popupService.close();
  }
}

// Usage in any component:
export class ExampleComponent {
  constructor(private popup: PopupService) {}

  showSuccess() {
    this.popup.success('Operation completed successfully!');
  }

  showError() {
    this.popup.error('Something went wrong!');
  }
}